module.exports = __webpack_public_path__ + "media/images/chat-ding-27b3539d88faa299c72a6882c873bf81.mp3";